import React, { useState, useEffect, useMemo, useContext } from "react";

// Firebase
import { firestore, auth } from "../firebase";
// Firebase

const UsuarioContext = React.createContext();

export function UsuarioProvider(props) {
  const [dataUser, setDataUser] = useState(null);
  const [loadUser, setLoadUser] = useState(true);
  const [loadConfig, setLoadConfig] = useState(true);
  const [config, setCofig] = useState(null);

  useEffect(() => {
    const unlisten = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        firestore
          .collection("registeredUsers")
          .doc(authUser.uid)
          .onSnapshot((docUC) => {
            console.log(docUC.exists);
            if (docUC.exists) {
              setTimeout(() => {
                let userData = docUC.data();
                setDataUser(userData);
                setLoadUser(false);
              }, 2000);
            } else {
              setTimeout(() => {
                setLoadUser(false);
              }, 2000);
            }
          });
      } else {
        setTimeout(() => {
          console.log("Reiniciado");
          setDataUser(null);
          setLoadUser(false);
        }, 2000);
      }
    });
    return () => {
      unlisten();
    };
  }, []);

  useEffect(() => {
    const onConfig = firestore
      .collection("config")
      .doc("config")
      .onSnapshot((doc) => {
        setTimeout(() => {
          setCofig(doc.data());
          setLoadConfig(false);
        }, 2000);
      });
    return () => {
      onConfig();
    };
  }, [dataUser]);

  const value = useMemo(() => {
    return {
      dataUser,
      loadUser,
      loadConfig,
      config,
    };
  }, [dataUser, loadUser, loadConfig, config]);

  return <UsuarioContext.Provider value={value} {...props} />;
}

export function useUsuario() {
  const context = useContext(UsuarioContext);
  if (!context) {
    throw new Error(
      "useUsuario debe estar dentro del proveedor UsuarioContext"
    );
  }
  return context;
}
